import * as React from 'react';
import { 
  DialogContent,
  IconButton,
  InputAdornment
} from '@mui/material';
import { useDispatch } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { CDialog, CDialogTitle, CDialogActions, CButton, CTextField } from '../components/common/Modal';
import { checkSourceAuth } from '../slices/source';

export default function AuthModal(props) {
  const dispatch = useDispatch();

  const {open, sourceName, handleSave, handleClose} = props;
  const [username, setUsername] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [showPassword, setShowPassword] = React.useState(false);

  const handleUsername = (e) => {
    setUsername(e.target.value)
  }
  
  const handlePassword = (e) => {
    setPassword(e.target.value)
  }
  const handleClickShowPassword = () => setShowPassword((prev) => !prev);
  
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleCheckAuthentication = () => {
    let formData = new FormData()
    formData.append('name', sourceName)
    formData.append('username', username)
    formData.append('password', password)
    
    dispatch(checkSourceAuth(formData))
      .unwrap()
      .then((response) => {
        if (response.is_connected) {
          // Save user credentials for the session
          handleSaveCredentials(response);
        }
      })
      .catch((error) => {
        console.error('Authentication failed:', error);
      });
  }

  const handleSaveCredentials = (authResponse) => {
    // This will be implemented to save credentials to the backend
    console.log('Saving credentials for:', sourceName, authResponse);
    // Close modal after successful authentication
    handleClose();
  }
 
  return (
    <>
      <CDialog
        open={open}
        onClose={handleClose}
        maxWidth={"xs"}
        fullWidth
      >
        <CDialogTitle>Authentication</CDialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 6,
            top: 6,
            color: (theme) => theme.palette.grey[800],
          }}
        >
          <CloseIcon fontSize='small' />
        </IconButton>
        <DialogContent>
          <CTextField
            required
            margin="dense"
            id="db-username"
            name="db-username"
            label="Username"
            type="text"
            size="small"
            fullWidth
            variant="outlined"
            value={username}
            onChange={handleUsername}
          />
          <CTextField
            required
            margin="dense"
            id="db-password"
            name="db-password"
            label="Password"
            type= {showPassword ? 'text' : 'password'}
            size="small"
            fullWidth
            variant="outlined"
            value={password}
            onChange={handlePassword}
            InputProps={{
              endAdornment: (<InputAdornment position="end">
                <IconButton
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>)
            }}
          />
        </DialogContent>
        <CDialogActions>
          <CButton onClick={handleClose}>Cancel</CButton>
          <CButton onClick={handleCheckAuthentication}>Ok</CButton>
        </CDialogActions>
      </CDialog>
    </>
  )
}